import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import addLogDocument from "./addLogDocument.js";
import { auth } from "../config/FirebaseConfig.js";
import { getUserById } from "../models/UserFunctions.js";

const fetchFacadeUrlFromHexagone = async (carnetId, prefix) => {
  const token = await getOrRefreshFirebaseToken();
  const url = `${prefix}carnets/${carnetId}/facade/from_hexagone`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const start = new Date();
    const response = await fetch(url, {
      method: "POST",
      headers,
    });

    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new Error("User not logged in");
    }

    const userData = await getUserById(currentUser.uid);
    const responseText = await response.text();
    const end = new Date();
    const elapsed = end - start;

    if (userData) {
      const orgId = userData.org_id;
      await addLogDocument(
        url,
        prefix,
        currentUser.uid,
        orgId,
        response.status.toString(),
        "",
        carnetId,
        "",
        responseText,
        "POST",
        elapsed
      );
    }

    if (response.ok) {
      return JSON.parse(responseText);
    } else {
      console.error(`Failed to fetch facade URL from Hexagone: ${response.status}`);
      throw new Error(`Failed to fetch facade URL from Hexagone: ${response.status}`);
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    throw error;
  }
};

export default fetchFacadeUrlFromHexagone;